import React from "react";
import {
  Box,
  Grid,
  CircularProgress,
  List,
  ListItem,
  ListItemButton,
  Divider,
  Chip,
  Typography
} from "@mui/material";

const SearchResults = ({ users, searching, openUser }) => {
  const mapTier = (val) => {
    switch (val) {
      case 0:
        return "None";
      case 1:
        return "Free";
      case 2:
        return "Silver";
      case 3:
        return "Gold";

      default:
        return "";
    }
  };

  if (searching) {
    return (
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          padding: 50,
        }}
      >
        <CircularProgress size={75} />
      </div>
    );
  }
  return (
    <Box sx={{ borderTop: 1, borderColor: "divider", padding: 3 }}>
      <Typography variant="subtitle2" align="center">{users.length} Matching Users</Typography>
      <List>
        {users.map((user) => {
          return (
            <div key={user._id}>
              <ListItem >
                <ListItemButton onClick={() => openUser(user)}>
                  <Grid container>
                    <Grid item xs={3}>
                      {user?.profile?.firstName} {user?.profile?.lastName}
                    </Grid>
                    <Grid item xs={1}>
                      <Chip label={mapTier(user?.matchmakingTier)} size="small"/>
                    </Grid>
                  </Grid>
                </ListItemButton>
              </ListItem>
              <Divider />
            </div>
          );
        })}
      </List>
    </Box>
  );
};

export default SearchResults;
